// packages/web/src/components/service/InstallDateDisplay.tsx
// Reusable install date display component

import ScheduleIcon from '@mui/icons-material/Schedule';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { calculateInstallDate } from '../../utils/installDateUtils';

interface ServiceData {
  installation_days_estimate?: number;
  expected_install_time_days?: number;
  validation_days_estimate?: number;
  expected_availability_hours?: number;
  expected_contract_hours?: number;
  [key: string]: any;
}

interface InstallDateDisplayProps {
  service: ServiceData;
  showIcon?: boolean;
  variant?: 'body2' | 'caption';
}

export const InstallDateDisplay: React.FC<InstallDateDisplayProps> = ({
  service,
  showIcon = true,
  variant = 'body2'
}) => {
  const { formattedInstallDate } = calculateInstallDate(service);

  // Show fallback message if no timing data is available
  if (formattedInstallDate === 'TBD') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        {showIcon && <ScheduleIcon sx={{ color: 'action', fontSize: '1rem' }} />}
        <Typography variant={variant} color="text.secondary" sx={{ fontStyle: 'italic' }}>
          Timeframe unavailable
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      {showIcon && <ScheduleIcon sx={{ color: 'action', fontSize: '1rem' }} />}
      <Typography variant={variant} color="text.secondary">
        Install by: {formattedInstallDate}
      </Typography>
    </Box>
  );
};